import type { OperationalTuningTargetConfig } from './flows/retune-target-selection';

const ACTIVE_BLADE_AREA_KHZ = new Set([33, 39, 46, 47]);

export function resolveActiveBladeAreaImageSrc(
  target: Pick<OperationalTuningTargetConfig, 'center_frequency_hz'> | null | undefined
): string | null {
  if (!target || !Number.isFinite(target.center_frequency_hz)) {
    return null;
  }

  const roundedKhz = Math.round(target.center_frequency_hz / 1000);
  return ACTIVE_BLADE_AREA_KHZ.has(roundedKhz)
    ? resolveAppAssetPath(`active-blade-area/${roundedKhz}k.png`)
    : null;
}

function resolveAppAssetPath(path: string): string {
  const baseUrl = import.meta.env.BASE_URL || './';
  const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  return `${normalizedBaseUrl}${path.replace(/^\/+/, '')}`;
}
